import React from "react";
import { Form, Input } from "antd";
import { withTranslation } from "react-i18next";

const lang = window.lang;

const FormItem = Form.Item;

const RenderField = (props) => {
  const { t, mt } = props;
  const {
    input,
    label,
    type,
    hint,
    formItemLayout,
    meta: { touched, error, warning },
  } = props;
  return (
    <FormItem {...formItemLayout} extra={hint} className={`${mt ? mt : ""}`}>
      {
        <Input
          {...input}
          placeholder={label}
          type={type}
          className={`${"input-field "}`}
          id={props.id}
        />
      }
      {touched &&
        ((error && <span style={{ color: "red" }}>{t(error)}</span>) ||
          (warning && <span>{warning}</span>))}
    </FormItem>
  );
};

export default withTranslation()(RenderField);
